/*
https://splidejs.com/guides/getting-started/
*/

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener( 'DOMContentLoaded', function() {
    const slider = document.querySelector('.slider');

    if( slider ) {
        var splide = new Splide( '.slider' , {
            type: 'fade',
            speed: 1000,
            arrows: false,
            pagination: true,
            rewind: true,
            waitForTransition: false,
        });
        splide.mount();
    }

    const associations = document.querySelector('.associations-slide');

    if( associations ) {
        var splide2 = new Splide( '.associations-slide' , {
            type   : 'loop',
            drag   : 'free',
            focus  : 'center',
            direction: 'rtl',
            perPage: 5,
            autoWidth: true,
            gap: '6em',
            autoScroll: {
                speed: -1,
            },
            // perPage: 5,
            // perMove: 1,
            // type: 'loop',
            speed: 800,
            // interval: 4000,
            arrows: false,
            pagination: false,
            // rewind: true,
            breakpoints: {
                768: {
                    perPage: 2,
                },
                960: {
                    perPage: 2,
                },
                1100: {
                    perPage: 3,
                },
            }
        });
        splide2.mount(window.splide.Extensions);
    }

    const patient = document.querySelector('.patient-slide');

    if( patient ) {
        var splide3 = new Splide( '.patient-slide' , {
            perPage: 3,
            perMove: 1,
            type: 'slide',
            speed: 1000,
            arrows: false,
            pagination: false,
            rewind: false,
            gap: '25px',
            clones: 4,
            padding: { left: '0rem', right: '0rem' },
            breakpoints: {
                768: {
                    perPage: 1,
                },
                1024: {
                    perPage: 2,
                },
                1100: {
                    perPage: 3,
                },
            }
        });
        splide3.mount();
    }

    const skinQuiz = document.querySelector('.quiz-slide');

    if( skinQuiz ) {
        var splide4 = new Splide( '.quiz-slide' , {
            perPage: 1,
            perMove: 1,
            type: 'slide',
            drag: false,
            speed: 1000,
            arrows: false,
            pagination: false,
            rewind: false,
            gap: '25px',
            clones: 4,
            padding: { left: '0rem', right: '0rem' },
            breakpoints: {
                768: {
                    perPage: 1,
                },
                1024: {
                    perPage: 1,
                },
                1100: {
                    perPage: 1,
                },
            }
        });
        splide4.mount();

        document.getElementById('goStart').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });
        
        document.getElementById('goStep1').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep1').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });

        document.getElementById('goStep2').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep2').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });

        document.getElementById('goStep3').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep3').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });

        document.getElementById('goStep4').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep4').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });

        //
        document.getElementById('goStep5').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep5').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });

        document.getElementById('goStep6').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep6').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });

        document.getElementById('goStep7').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep7').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });

        document.getElementById('goStep8').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep8').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });


        document.getElementById('goStep9').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

        document.getElementById('goBackStep9').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('<');
        });

        document.getElementById('goStep10').addEventListener('click', function (e) {
            e.preventDefault();
            splide4.go('>');
        });

    }

    var checkboxes = document.querySelectorAll('input[type=checkbox]');

    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                this.closest('.wpcf7-list-item').classList.add('checked');
            } else {
                this.closest('.wpcf7-list-item').classList.remove('checked');
            }
        });
    });
	
});